import axios from "axios";
import axiosRetry from "axios-retry";

/** API実行 */
const executeUnAuthApi  = async (
  baseURL: string,
  apiKey: string,
  path: string,
  retries: number = 0,
  requestBody?: Object
) => {
  let response;
  const axiosInstance = axios.create({
    baseURL: baseURL
  })
  // リトライ設定
  axiosRetry(axiosInstance, {
    retries: retries,
    retryCondition: () => true,
    retryDelay: () => 1000
  });
  const config = {
    headers: {
      "Content-Type": "application/json",
      "x-api-key": apiKey
    }
  };
  try {
    response = await axiosInstance.post(
      path,
      requestBody,
      config
    )
  } catch (e) {
    return false;
  }
  return response;
};

export default executeUnAuthApi ;
